import { Link } from 'react-router-dom';
import { Button, ThemeProvider, createTheme } from '@mui/material';

type Props = {
  title: string;
  path?: string;
  url?: string;
  className?: string;
  onClick?: () => void;
};

export const LinkButton = (props: Props) => {
  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: 'var(--c-button-text)',
            background: 'var(--c-button-background)',
            borderRadius: '300px',
            padding: '8px 16px',
            minWidth: '120px',
            fontWeight: 'bold',
            '&:hover': {
              background: 'var(--c-button-background-hover)',
            },
            '&:focus': {
              background: 'var(--c-button-background-hover)',
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {(() => {
        if (props.path != null) {
          return (
            <Button
              variant="contained"
              component={Link}
              to={props.path}
              disableElevation
              className={props.className}
              onClick={props.onClick}
              title={props.title}
            >
              {props.title}
            </Button>
          );
        } else if (props.url != null) {
          return (
            <Button
              variant="contained"
              target="_blank"
              href={props.url}
              disableElevation
              className={props.className}
              onClick={props.onClick}
              title={props.title}
            >
              {props.title}
            </Button>
          );
        }
      })()}
    </ThemeProvider>
  );
};
